export default "__VITE_ASSET__nEdIXyz$__"